import { arrayOf } from 'prop-types';
import React from 'react';

import {
  getCoInvest,
  getFreeService,
  getNetClientBudgetExternal,
  getOpenBudget,
  getSpendableBudget,
  getWkzBudget,
} from '../../campaigns/utils/get-budgets';
import { opportunityShape, optionShape } from '../../prop-types';
import OpportunityCard from '../OpportunityCard';
import getAggregatedExpectedRevenue from '../utils/get-expected-revenue';
import LaneBudgets from './LaneBudgets';

class OpportunityLane extends React.PureComponent {
  render() {
    const { category, opportunities } = this.props;

    const expectedRevenue = getAggregatedExpectedRevenue(opportunities);
    const openBudget = getOpenBudget(opportunities);
    const netClientBudgetExternal = getNetClientBudgetExternal(opportunities);
    const wkzBudget = getWkzBudget(opportunities);
    const coInvest = getCoInvest(opportunities);
    const freeService = getFreeService(opportunities);
    const spendableBudget = getSpendableBudget(opportunities);

    return (
      <div>
        <div className="c-progress_select--small bg-primary text-center">
          {category.label}
          <small className="pl-1">({opportunities.length})</small>
        </div>
        {!!opportunities.length && (
          <LaneBudgets
            expectedRevenue={expectedRevenue}
            openBudget={openBudget}
            netClientBudgetExternal={netClientBudgetExternal}
            coInvest={coInvest}
            freeService={freeService}
            wkzBudget={wkzBudget}
            spendableBudget={spendableBudget}
          />
        )}
        <div className="c-swimlanes-card-pool">
          {opportunities.map(opportunity => (
            <OpportunityCard key={opportunity.id} opportunity={opportunity} />
          ))}
        </div>
      </div>
    );
  }
}

OpportunityLane.propTypes = {
  category: optionShape.isRequired,
  opportunities: arrayOf(opportunityShape.isRequired).isRequired,
};

export default OpportunityLane;
